import { publicMessages } from "./public-messages";

export const PUBLIC_LOCALE_COOKIE = "optrixis_public_locale";
export const PUBLIC_LOCALE_HEADER = "x-optrixis-public-locale";
export const publicLocales = ["en", "fr", "ar"] as const;
export type PublicLocale = typeof publicLocales[number];
export function withPublicLocale(href: string, locale: PublicLocale) {
  const url = new URL(href, "https://public.invalid");
  if (locale !== "en" || url.searchParams.has("lang")) url.searchParams.set("lang", locale);
  return href.startsWith("/") ? `${url.pathname}${url.search}${url.hash}` : url.href;
}
export function publicLocale(value: unknown): PublicLocale { return value === "fr" || value === "ar" ? value : "en"; }
export function publicPagePath(path: string) {
  return path === "/" || /^\/(platform|pricing|about|contact|book-demo|enterprise|security|faq|blog|request-access|reviews|local-seo|ai|local-score|priority-actions|integrations|industries|ma|privacy|terms|data-deletion|checkout|sign-in|sign-up|verify-email|consent)(\/|$)/.test(path);
}

/** Values such as provider identifiers, JSX nodes, booleans and numbers pass
 * through unchanged. Translation occurs during rendering, on server and client.
 */
export function translatePublic<T>(locale: PublicLocale, value: T): T {
  if (locale === "en" || typeof value !== "string") return value;
  const key = value.replace(/\s+/g, " ").trim();
  const translated = publicMessages[key]?.[locale];
  if (translated !== undefined) return `${/^\s/.test(value) ? " " : ""}${translated}${/\s$/.test(value) ? " " : ""}` as T;
  const lengthError = /^Use (\d+) characters or fewer\.$/.exec(key);
  if (lengthError) return (locale === "fr" ? `Utilisez au maximum ${lengthError[1]} caractères.` : `استخدم ${lengthError[1]} حرفًا كحد أقصى.`) as T;
  const choose = /^Choose (Start|Growth|Pro)$/.exec(key);
  if (choose) return (locale === "fr" ? `Choisir ${choose[1]}` : `اختر ${choose[1]}`) as T;
  return value;
}
